if !sandbox
    .preview-area
            .mask
            .flow-steps
                if skippable
                    .appcues-skip
                        a.skip(data-step="skip" title='Skip') &times;
else
    .preview-area.sandboxed
